import { useMemo } from "react";

import { Mention } from "../tiptap-extension/mention-extension";

export function useMentionExtension() {
  const mentionExtension = useMemo(() => {
    return Mention.configure({
      HTMLAttributes: {
        class: "mention",
      },
    });
  }, []);

  return mentionExtension;
}

